import { render } from "./UiModal.vue?vue&type=template&id=f0c81f5e"
import script from "./UiModal.vue?vue&type=script&lang=js"
export * from "./UiModal.vue?vue&type=script&lang=js"

import "./UiModal.vue?vue&type=style&index=0&id=f0c81f5e&lang=scss"

import exportComponent from "/home/ubuntu/actions-runner/_work/frontend/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__